export function normalizeChatPanelSessionId(
  sessionId: string | null | undefined
): string | undefined {
  if (!sessionId || sessionId === 'undefined' || sessionId === 'null') {
    return undefined;
  }
  return sessionId;
}

export function createChatPanelDocPath(
  docId: string,
  sessionId?: string | null
): string {
  const normalizedSessionId = normalizeChatPanelSessionId(sessionId);
  if (!normalizedSessionId) return `/${docId}`;

  const params = new URLSearchParams({ sessionId: normalizedSessionId });
  return `/${docId}?${params.toString()}`;
}
